import take from "lodash/take";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { articleAuthorDetailsContent$key } from "~/queries/__generated__/articleAuthorDetailsContent.graphql";

import { AuthorCard } from "./author-card";
import type { AuthorCardsContainerProps } from "./styles";
import { AuthorCardsContainer } from "./styles";

export type Props = {
  className?: string;
  firstNthAuthor?: number;
  reference: articleAuthorDetailsContent$key;
  variant?: AuthorCardsContainerProps["$variant"];
};

export const ArticleAuthorsDetails: FunctionComponent<Props> = ({
  className,
  firstNthAuthor,
  reference: reference_,
  variant = "light",
}) => {
  const content = useFragment(
    graphql`
      fragment articleAuthorDetailsContent on Content {
        authors {
          entityId
          ...authorCardAuthor
          bio
        }
      }
    `,
    reference_,
  );

  const authors = firstNthAuthor ? take(content.authors, firstNthAuthor) : content.authors;

  const validAuthors = authors?.filter(author => author?.bio) ?? [];
  const validAuthorsLength = validAuthors?.length ?? 0;
  if (!content || validAuthorsLength === 0) return null;
  return (
    <AuthorCardsContainer $variant={variant} className={className}>
      {authors
        ?.filter(author => author?.bio)
        .map(author => author && <AuthorCard key={author.entityId} reference={author} />)}
    </AuthorCardsContainer>
  );
};

ArticleAuthorsDetails.displayName = "ArticleAuthorsDetails";
